import React from 'react';

import DateRangeFilter from '../../../components/Filters/DateRangeFilter';

import { TFuncKey, withTranslation } from 'react-i18next';
import { FilterProps } from './FilterProps';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

export interface TransactionDateRangeProps extends FilterProps {
    isRangeUnlimited?: boolean;
    name: string;
    label: TFuncKey<'app'>;
}

const TransactionDateRangeFilter = (
    {
        queryParams,
        onChange,
        isRangeUnlimited,
        name,
        label,
        t,
    }: TransactionDateRangeProps
) => {
    const gteKey = `${name}.gte`;
    const lteKey = `${name}.lte`;
    const values =
        queryParams.get(gteKey) && queryParams.get(lteKey)
            ? {
                from: queryParams.get(gteKey) || '',
                to: queryParams.get(lteKey) || '',
            }
            : undefined;

    const formatDate = (str: string) => format(parseISO(str), 'yyyy-MM-dd');
    const translatedLabel = values
        ? t(label, {
            value: (values.from === values.to
                ? formatDate(values.from)
                : `${formatDate(values.from)} – ${formatDate(values.to)}`
            ),
        })
        : t('components.filters.date_range.label_no_dates_set');
    return (
        <DateRangeFilter
            name={name}
            label={translatedLabel}
            values={values}
            onApply={(_, values) => {
                onChange({
                    [gteKey]: [values.from],
                    [lteKey]: [values.to],
                });
            }}
            onDelete={_ => {
                onChange({
                    [gteKey]: [],
                    [lteKey]: [],
                });
            }}
            isRangeUnlimited={!!isRangeUnlimited}
            outputDateFormat={'iso'}
            endInclusive={true}
        />
    );
};

export default withTranslation()(TransactionDateRangeFilter);
